export interface Timezone {
    dst: boolean;
    offset: number;
    timezone_id: string;
    abbreviation: string;
}

/**
 * Generated with generate-timezones.php in PHP version 8.1.26.
 */
export const timezones: Array<Timezone> = [
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Abidjan",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Accra",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Addis_Ababa",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Algiers",
        "abbreviation": "CET"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Asmara",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Bamako",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Bangui",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Banjul",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Bissau",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Blantyre",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Brazzaville",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Bujumbura",
        "abbreviation": "CAT"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Africa/Cairo",
        "abbreviation": "EEST"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Casablanca",
        "abbreviation": "+01"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Africa/Ceuta",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Conakry",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Dakar",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Dar_es_Salaam",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Djibouti",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Douala",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/El_Aaiun",
        "abbreviation": "+01"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Freetown",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Gaborone",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Harare",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Johannesburg",
        "abbreviation": "SAST"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Juba",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Kampala",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Khartoum",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Kigali",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Kinshasa",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Lagos",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Libreville",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Lome",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Luanda",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Lubumbashi",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Lusaka",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Malabo",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Maputo",
        "abbreviation": "CAT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Maseru",
        "abbreviation": "SAST"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Mbabane",
        "abbreviation": "SAST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Mogadishu",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Monrovia",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Africa/Nairobi",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Ndjamena",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Niamey",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Nouakchott",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Ouagadougou",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Porto-Novo",
        "abbreviation": "WAT"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Africa/Sao_Tome",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Tripoli",
        "abbreviation": "EET"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Africa/Tunis",
        "abbreviation": "CET"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Africa/Windhoek",
        "abbreviation": "CAT"
    },
    {
        "dst": true,
        "offset": -32400,
        "timezone_id": "America/Adak",
        "abbreviation": "HDT"
    },
    {
        "dst": true,
        "offset": -28800,
        "timezone_id": "America/Anchorage",
        "abbreviation": "AKDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Anguilla",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Antigua",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Araguaina",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Buenos_Aires",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Catamarca",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Cordoba",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Jujuy",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/La_Rioja",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Mendoza",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Rio_Gallegos",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Salta",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/San_Juan",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/San_Luis",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Tucuman",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Argentina/Ushuaia",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Aruba",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Asuncion",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Atikokan",
        "abbreviation": "EST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Bahia",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Bahia_Banderas",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Barbados",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Belem",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Belize",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Blanc-Sablon",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Boa_Vista",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Bogota",
        "abbreviation": "-05"
    },
    {
        "dst": true,
        "offset": -21600,
        "timezone_id": "America/Boise",
        "abbreviation": "MDT"
    },
    {
        "dst": true,
        "offset": -21600,
        "timezone_id": "America/Cambridge_Bay",
        "abbreviation": "MDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Campo_Grande",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Cancun",
        "abbreviation": "EST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Caracas",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Cayenne",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Cayman",
        "abbreviation": "EST"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Chicago",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Chihuahua",
        "abbreviation": "CST"
    },
    {
        "dst": true,
        "offset": -21600,
        "timezone_id": "America/Ciudad_Juarez",
        "abbreviation": "MDT"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Costa_Rica",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Creston",
        "abbreviation": "MST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Cuiaba",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Curacao",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "America/Danmarkshavn",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Dawson",
        "abbreviation": "MST"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Dawson_Creek",
        "abbreviation": "MST"
    },
    {
        "dst": true,
        "offset": -21600,
        "timezone_id": "America/Denver",
        "abbreviation": "MDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Detroit",
        "abbreviation": "EDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Dominica",
        "abbreviation": "AST"
    },
    {
        "dst": true,
        "offset": -21600,
        "timezone_id": "America/Edmonton",
        "abbreviation": "MDT"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Eirunepe",
        "abbreviation": "-05"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/El_Salvador",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Fort_Nelson",
        "abbreviation": "MST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Fortaleza",
        "abbreviation": "-03"
    },
    {
        "dst": true,
        "offset": -10800,
        "timezone_id": "America/Glace_Bay",
        "abbreviation": "ADT"
    },
    {
        "dst": true,
        "offset": -10800,
        "timezone_id": "America/Goose_Bay",
        "abbreviation": "ADT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Grand_Turk",
        "abbreviation": "EDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Grenada",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Guadeloupe",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Guatemala",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Guayaquil",
        "abbreviation": "-05"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Guyana",
        "abbreviation": "-04"
    },
    {
        "dst": true,
        "offset": -10800,
        "timezone_id": "America/Halifax",
        "abbreviation": "ADT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Havana",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Hermosillo",
        "abbreviation": "MST"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Indiana/Indianapolis",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Indiana/Knox",
        "abbreviation": "CDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Indiana/Marengo",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Indiana/Petersburg",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Indiana/Tell_City",
        "abbreviation": "CDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Indiana/Vevay",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Indiana/Vincennes",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Indiana/Winamac",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -21600,
        "timezone_id": "America/Inuvik",
        "abbreviation": "MDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Iqaluit",
        "abbreviation": "EDT"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Jamaica",
        "abbreviation": "EST"
    },
    {
        "dst": true,
        "offset": -28800,
        "timezone_id": "America/Juneau",
        "abbreviation": "AKDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Kentucky/Louisville",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Kentucky/Monticello",
        "abbreviation": "EDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Kralendijk",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/La_Paz",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Lima",
        "abbreviation": "-05"
    },
    {
        "dst": true,
        "offset": -25200,
        "timezone_id": "America/Los_Angeles",
        "abbreviation": "PDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Lower_Princes",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Maceio",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Managua",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Manaus",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Marigot",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Martinique",
        "abbreviation": "AST"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Matamoros",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Mazatlan",
        "abbreviation": "MST"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Menominee",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Merida",
        "abbreviation": "CST"
    },
    {
        "dst": true,
        "offset": -28800,
        "timezone_id": "America/Metlakatla",
        "abbreviation": "AKDT"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Mexico_City",
        "abbreviation": "CST"
    },
    {
        "dst": true,
        "offset": -7200,
        "timezone_id": "America/Miquelon",
        "abbreviation": "-02"
    },
    {
        "dst": true,
        "offset": -10800,
        "timezone_id": "America/Moncton",
        "abbreviation": "ADT"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Monterrey",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Montevideo",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Montserrat",
        "abbreviation": "AST"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Nassau",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/New_York",
        "abbreviation": "EDT"
    },
    {
        "dst": true,
        "offset": -28800,
        "timezone_id": "America/Nome",
        "abbreviation": "AKDT"
    },
    {
        "dst": false,
        "offset": -7200,
        "timezone_id": "America/Noronha",
        "abbreviation": "-02"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/North_Dakota/Beulah",
        "abbreviation": "CDT"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/North_Dakota/Center",
        "abbreviation": "CDT"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/North_Dakota/New_Salem",
        "abbreviation": "CDT"
    },
    {
        "dst": true,
        "offset": -3600,
        "timezone_id": "America/Nuuk",
        "abbreviation": "-01"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Ojinaga",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Panama",
        "abbreviation": "EST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Paramaribo",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Phoenix",
        "abbreviation": "MST"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Port-au-Prince",
        "abbreviation": "EDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Port_of_Spain",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Porto_Velho",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Puerto_Rico",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Punta_Arenas",
        "abbreviation": "-03"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Rankin_Inlet",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Recife",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Regina",
        "abbreviation": "CST"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Resolute",
        "abbreviation": "CDT"
    },
    {
        "dst": false,
        "offset": -18000,
        "timezone_id": "America/Rio_Branco",
        "abbreviation": "-05"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Santarem",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Santiago",
        "abbreviation": "-04"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Santo_Domingo",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "America/Sao_Paulo",
        "abbreviation": "-03"
    },
    {
        "dst": true,
        "offset": 0,
        "timezone_id": "America/Scoresbysund",
        "abbreviation": "+00"
    },
    {
        "dst": true,
        "offset": -28800,
        "timezone_id": "America/Sitka",
        "abbreviation": "AKDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/St_Barthelemy",
        "abbreviation": "AST"
    },
    {
        "dst": true,
        "offset": -9000,
        "timezone_id": "America/St_Johns",
        "abbreviation": "NDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/St_Kitts",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/St_Lucia",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/St_Thomas",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/St_Vincent",
        "abbreviation": "AST"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Swift_Current",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "America/Tegucigalpa",
        "abbreviation": "CST"
    },
    {
        "dst": true,
        "offset": -10800,
        "timezone_id": "America/Thule",
        "abbreviation": "ADT"
    },
    {
        "dst": true,
        "offset": -25200,
        "timezone_id": "America/Tijuana",
        "abbreviation": "PDT"
    },
    {
        "dst": true,
        "offset": -14400,
        "timezone_id": "America/Toronto",
        "abbreviation": "EDT"
    },
    {
        "dst": false,
        "offset": -14400,
        "timezone_id": "America/Tortola",
        "abbreviation": "AST"
    },
    {
        "dst": true,
        "offset": -25200,
        "timezone_id": "America/Vancouver",
        "abbreviation": "PDT"
    },
    {
        "dst": false,
        "offset": -25200,
        "timezone_id": "America/Whitehorse",
        "abbreviation": "MST"
    },
    {
        "dst": true,
        "offset": -18000,
        "timezone_id": "America/Winnipeg",
        "abbreviation": "CDT"
    },
    {
        "dst": true,
        "offset": -28800,
        "timezone_id": "America/Yakutat",
        "abbreviation": "AKDT"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Antarctica/Casey",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Antarctica/Davis",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Antarctica/DumontDUrville",
        "abbreviation": "+10"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Antarctica/Macquarie",
        "abbreviation": "AEST"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Antarctica/Mawson",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Antarctica/McMurdo",
        "abbreviation": "NZST"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "Antarctica/Palmer",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "Antarctica/Rothera",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Antarctica/Syowa",
        "abbreviation": "+03"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Antarctica/Troll",
        "abbreviation": "+02"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Antarctica/Vostok",
        "abbreviation": "+06"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Arctic/Longyearbyen",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Aden",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Almaty",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Amman",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Asia/Anadyr",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Aqtau",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Aqtobe",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Ashgabat",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Atyrau",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Baghdad",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Bahrain",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Asia/Baku",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Bangkok",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Barnaul",
        "abbreviation": "+07"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Asia/Beirut",
        "abbreviation": "EEST"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Bishkek",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Brunei",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Chita",
        "abbreviation": "+09"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Choibalsan",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 19800,
        "timezone_id": "Asia/Colombo",
        "abbreviation": "+0530"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Damascus",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Dhaka",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Dili",
        "abbreviation": "+09"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Asia/Dubai",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Dushanbe",
        "abbreviation": "+05"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Asia/Famagusta",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Asia/Gaza",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Asia/Hebron",
        "abbreviation": "EEST"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Ho_Chi_Minh",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Hong_Kong",
        "abbreviation": "HKT"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Hovd",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Irkutsk",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Jakarta",
        "abbreviation": "WIB"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Jayapura",
        "abbreviation": "WIT"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Asia/Jerusalem",
        "abbreviation": "IDT"
    },
    {
        "dst": false,
        "offset": 16200,
        "timezone_id": "Asia/Kabul",
        "abbreviation": "+0430"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Asia/Kamchatka",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Karachi",
        "abbreviation": "PKT"
    },
    {
        "dst": false,
        "offset": 20700,
        "timezone_id": "Asia/Kathmandu",
        "abbreviation": "+0545"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Khandyga",
        "abbreviation": "+09"
    },
    {
        "dst": false,
        "offset": 19800,
        "timezone_id": "Asia/Kolkata",
        "abbreviation": "IST"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Krasnoyarsk",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Kuala_Lumpur",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Kuching",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Kuwait",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Macau",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Asia/Magadan",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Makassar",
        "abbreviation": "WITA"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Manila",
        "abbreviation": "PST"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Asia/Muscat",
        "abbreviation": "+04"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Asia/Nicosia",
        "abbreviation": "EEST"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Novokuznetsk",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Novosibirsk",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Omsk",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Oral",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Phnom_Penh",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Pontianak",
        "abbreviation": "WIB"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Pyongyang",
        "abbreviation": "KST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Qatar",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Qostanay",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Qyzylorda",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Asia/Riyadh",
        "abbreviation": "+03"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Asia/Sakhalin",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Samarkand",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Seoul",
        "abbreviation": "KST"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Shanghai",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Singapore",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Asia/Srednekolymsk",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Taipei",
        "abbreviation": "CST"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Tashkent",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Asia/Tbilisi",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 12600,
        "timezone_id": "Asia/Tehran",
        "abbreviation": "+0330"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Thimphu",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Tokyo",
        "abbreviation": "JST"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Tomsk",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Asia/Ulaanbaatar",
        "abbreviation": "+08"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Asia/Urumqi",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Asia/Ust-Nera",
        "abbreviation": "+10"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Asia/Vientiane",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Asia/Vladivostok",
        "abbreviation": "+10"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Asia/Yakutsk",
        "abbreviation": "+09"
    },
    {
        "dst": false,
        "offset": 23400,
        "timezone_id": "Asia/Yangon",
        "abbreviation": "+0630"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Asia/Yekaterinburg",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Asia/Yerevan",
        "abbreviation": "+04"
    },
    {
        "dst": true,
        "offset": 0,
        "timezone_id": "Atlantic/Azores",
        "abbreviation": "+00"
    },
    {
        "dst": true,
        "offset": -10800,
        "timezone_id": "Atlantic/Bermuda",
        "abbreviation": "ADT"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Atlantic/Canary",
        "abbreviation": "WEST"
    },
    {
        "dst": false,
        "offset": -3600,
        "timezone_id": "Atlantic/Cape_Verde",
        "abbreviation": "-01"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Atlantic/Faroe",
        "abbreviation": "WEST"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Atlantic/Madeira",
        "abbreviation": "WEST"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Atlantic/Reykjavik",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": -7200,
        "timezone_id": "Atlantic/South_Georgia",
        "abbreviation": "-02"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "Atlantic/St_Helena",
        "abbreviation": "GMT"
    },
    {
        "dst": false,
        "offset": -10800,
        "timezone_id": "Atlantic/Stanley",
        "abbreviation": "-03"
    },
    {
        "dst": false,
        "offset": 34200,
        "timezone_id": "Australia/Adelaide",
        "abbreviation": "ACST"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Australia/Brisbane",
        "abbreviation": "AEST"
    },
    {
        "dst": false,
        "offset": 34200,
        "timezone_id": "Australia/Broken_Hill",
        "abbreviation": "ACST"
    },
    {
        "dst": false,
        "offset": 34200,
        "timezone_id": "Australia/Darwin",
        "abbreviation": "ACST"
    },
    {
        "dst": false,
        "offset": 31500,
        "timezone_id": "Australia/Eucla",
        "abbreviation": "+0845"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Australia/Hobart",
        "abbreviation": "AEST"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Australia/Lindeman",
        "abbreviation": "AEST"
    },
    {
        "dst": false,
        "offset": 37800,
        "timezone_id": "Australia/Lord_Howe",
        "abbreviation": "+1030"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Australia/Melbourne",
        "abbreviation": "AEST"
    },
    {
        "dst": false,
        "offset": 28800,
        "timezone_id": "Australia/Perth",
        "abbreviation": "AWST"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Australia/Sydney",
        "abbreviation": "AEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Amsterdam",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Andorra",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Europe/Astrakhan",
        "abbreviation": "+04"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Athens",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Belgrade",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Berlin",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Bratislava",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Brussels",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Bucharest",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Budapest",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Busingen",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Chisinau",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Copenhagen",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 3600,
        "timezone_id": "Europe/Dublin",
        "abbreviation": "IST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Gibraltar",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Europe/Guernsey",
        "abbreviation": "BST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Helsinki",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Europe/Isle_of_Man",
        "abbreviation": "BST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Europe/Istanbul",
        "abbreviation": "+03"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Europe/Jersey",
        "abbreviation": "BST"
    },
    {
        "dst": false,
        "offset": 7200,
        "timezone_id": "Europe/Kaliningrad",
        "abbreviation": "EET"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Europe/Kirov",
        "abbreviation": "MSK"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Kyiv",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Europe/Lisbon",
        "abbreviation": "WEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Ljubljana",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 3600,
        "timezone_id": "Europe/London",
        "abbreviation": "BST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Luxembourg",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Madrid",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Malta",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Mariehamn",
        "abbreviation": "EEST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Europe/Minsk",
        "abbreviation": "+03"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Monaco",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Europe/Moscow",
        "abbreviation": "MSK"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Oslo",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Paris",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Podgorica",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Prague",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Riga",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Rome",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Europe/Samara",
        "abbreviation": "+04"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/San_Marino",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Sarajevo",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Europe/Saratov",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Europe/Simferopol",
        "abbreviation": "MSK"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Skopje",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Sofia",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Stockholm",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Tallinn",
        "abbreviation": "EEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Tirane",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Europe/Ulyanovsk",
        "abbreviation": "+04"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Vaduz",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Vatican",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Vienna",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 10800,
        "timezone_id": "Europe/Vilnius",
        "abbreviation": "EEST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Europe/Volgograd",
        "abbreviation": "MSK"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Warsaw",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Zagreb",
        "abbreviation": "CEST"
    },
    {
        "dst": true,
        "offset": 7200,
        "timezone_id": "Europe/Zurich",
        "abbreviation": "CEST"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Indian/Antananarivo",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 21600,
        "timezone_id": "Indian/Chagos",
        "abbreviation": "+06"
    },
    {
        "dst": false,
        "offset": 25200,
        "timezone_id": "Indian/Christmas",
        "abbreviation": "+07"
    },
    {
        "dst": false,
        "offset": 23400,
        "timezone_id": "Indian/Cocos",
        "abbreviation": "+0630"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Indian/Comoro",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Indian/Kerguelen",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Indian/Mahe",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 18000,
        "timezone_id": "Indian/Maldives",
        "abbreviation": "+05"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Indian/Mauritius",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 10800,
        "timezone_id": "Indian/Mayotte",
        "abbreviation": "EAT"
    },
    {
        "dst": false,
        "offset": 14400,
        "timezone_id": "Indian/Reunion",
        "abbreviation": "+04"
    },
    {
        "dst": false,
        "offset": 46800,
        "timezone_id": "Pacific/Apia",
        "abbreviation": "+13"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Auckland",
        "abbreviation": "NZST"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Bougainville",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 45900,
        "timezone_id": "Pacific/Chatham",
        "abbreviation": "+1245"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Pacific/Chuuk",
        "abbreviation": "+10"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "Pacific/Easter",
        "abbreviation": "-06"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Efate",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 46800,
        "timezone_id": "Pacific/Fakaofo",
        "abbreviation": "+13"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Fiji",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Funafuti",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": -21600,
        "timezone_id": "Pacific/Galapagos",
        "abbreviation": "-06"
    },
    {
        "dst": false,
        "offset": -32400,
        "timezone_id": "Pacific/Gambier",
        "abbreviation": "-09"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Guadalcanal",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Pacific/Guam",
        "abbreviation": "ChST"
    },
    {
        "dst": false,
        "offset": -36000,
        "timezone_id": "Pacific/Honolulu",
        "abbreviation": "HST"
    },
    {
        "dst": false,
        "offset": 46800,
        "timezone_id": "Pacific/Kanton",
        "abbreviation": "+13"
    },
    {
        "dst": false,
        "offset": 50400,
        "timezone_id": "Pacific/Kiritimati",
        "abbreviation": "+14"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Kosrae",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Kwajalein",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Majuro",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": -34200,
        "timezone_id": "Pacific/Marquesas",
        "abbreviation": "-0930"
    },
    {
        "dst": false,
        "offset": -39600,
        "timezone_id": "Pacific/Midway",
        "abbreviation": "SST"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Nauru",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": -39600,
        "timezone_id": "Pacific/Niue",
        "abbreviation": "-11"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Norfolk",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Noumea",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": -39600,
        "timezone_id": "Pacific/Pago_Pago",
        "abbreviation": "SST"
    },
    {
        "dst": false,
        "offset": 32400,
        "timezone_id": "Pacific/Palau",
        "abbreviation": "+09"
    },
    {
        "dst": false,
        "offset": -28800,
        "timezone_id": "Pacific/Pitcairn",
        "abbreviation": "-08"
    },
    {
        "dst": false,
        "offset": 39600,
        "timezone_id": "Pacific/Pohnpei",
        "abbreviation": "+11"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Pacific/Port_Moresby",
        "abbreviation": "+10"
    },
    {
        "dst": false,
        "offset": -36000,
        "timezone_id": "Pacific/Rarotonga",
        "abbreviation": "-10"
    },
    {
        "dst": false,
        "offset": 36000,
        "timezone_id": "Pacific/Saipan",
        "abbreviation": "ChST"
    },
    {
        "dst": false,
        "offset": -36000,
        "timezone_id": "Pacific/Tahiti",
        "abbreviation": "-10"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Tarawa",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 46800,
        "timezone_id": "Pacific/Tongatapu",
        "abbreviation": "+13"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Wake",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 43200,
        "timezone_id": "Pacific/Wallis",
        "abbreviation": "+12"
    },
    {
        "dst": false,
        "offset": 0,
        "timezone_id": "UTC",
        "abbreviation": "UTC"
    }
];
